import { useMemo } from 'react';
import { ModelItem } from 'src/types';
import { useModelStore } from 'src/stores/modelStore';
import { getItemByIdOrThrow } from 'src/utils';

export const useModelItem = (id: string): ModelItem | null => {
  const model = useModelStore((state) => {
    return state;
  });

  const modelItem = useMemo(() => {
    // Return null for empty IDs to prevent errors
    if (!id || id === '') {
      return null;
    }
    try {
      return getItemByIdOrThrow(model.items, id).value;
    } catch {
      return null;
    }
  }, [id, model.items]);

  return modelItem;
};
